import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: true,
    isSuccess: false,
    isError: false,
    success: false,
    error: false,
    employeeProfile_data: [],
    employee_time_data: [],
    employee_face_time_data:[]
}

export const EmployeeProfileReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.EMPLOYEE_PROFILE_PAYROLL_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            }
        case ActionTypes.EMPLOYEE_PROFILE_PAYROLL_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                employeeProfile_data: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYEE_PROFILE_PAYROLL_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
            case ActionTypes.EMPLOYEE_TIME_GET_REQUEST:
                return {
                    ...state,
                    isLoading: true,
                    success: false,
                    error: false,
                    employee_time_data: []
                };
            case ActionTypes.EMPLOYEE_TIME_GET_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    success: true,
                    successMessage: action.payload?.message,
                    employee_time_data: action.payload?.data?.data
                };
            case ActionTypes.EMPLOYEE_TIME_GET_ERROR:
                return {
                    ...state,
                    isLoading: false,
                    error: true,
                    success: false,
                    errorMessage: action.payload?.data?.error?.[0]?.message
                }
                case ActionTypes.EMPLOYEE_FACE_TIME_GET_REQUEST:
                return {
                    ...state,
                    isLoading: true,
                    success: false,
                    error: false,
                    employee_face_time_data: []
                };
            case ActionTypes.EMPLOYEE_FACE_TIME_GET_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    success: true,
                    successMessage: action.payload?.message,
                    employee_face_time_data: action.payload?.data?.data
                };
            case ActionTypes.EMPLOYEE_FACE_TIME_GET_ERROR:
                return {
                    ...state,
                    isLoading: false,
                    error: true,
                    success: false,
                    errorMessage: action.payload?.data?.error?.[0]?.message
                }
        default:
            return state
    }
}